// extracted by mini-css-extract-plugin
module.exports = {"buttonAdd":"PaymentList_buttonAdd__2r83f"};